import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { AnimatedBackground } from "../AnimatedBackground";
import { AnimatedBackgroundElement } from "../AnimatedBackgroundElement";
import pattern from "./pattern.svg";

import "./_animated-layout.scss";

export interface IAnimatedLayoutProps {}

export const AnimatedLayout: FC<IAnimatedLayoutProps> = ({ children }) => {
  const { ready } = useTranslation(["common", "public", "codelists"]);

  return (
    <>
      <AnimatedBackground>
        <AnimatedBackgroundElement bgImageSrc={pattern} yPos={0} />
      </AnimatedBackground>
      <div className="animated-layout">
        {ready && children}
        {/* Solution for no bottom padding visible at Firefox. See https://stackoverflow.com/a/22040425 */}
        <div className="animated-layout__bottom-placeholder" />
      </div>
    </>
  );
};
